import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "slider-container" }
const _hoisted_2 = { class: "slider-box" }
const _hoisted_3 = { class: "value-box" }
const _hoisted_4 = { class: "input-field" }
const _hoisted_5 = { class: "input-field" }
const _hoisted_6 = { class: "slider-values" }

import { ref, onMounted, watch } from 'vue'
import TextFieldStandard from '@/design-system/atoms/TextFieldStandard.vue'
import MinMaxRangeSlider from '@/design-system/molecules/MinMaxRangeSlider.vue'
import TextBase, { TextType } from '../atoms/TextBase.vue'
import { FormatOptions, formatter } from '@/components/AnalyticsDashboard/formatter'
import { useI18n } from 'vue-i18n'

type Props = {
  to: number
  from: number
  min: number
  max: number
  step: number
  fromColor: string
  toColor: string
  middleColor: string
  label: string
  labelType?: TextType
  format?: FormatOptions
}

type Emits = {
  (e: 'changeValue', value: { from: number; to: number }): void
  (e: 'updateValue', value: { from: number; to: number }): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MinMaxSliderFilter',
  props: {
    to: {},
    from: {},
    min: {},
    max: {},
    step: {},
    fromColor: {},
    toColor: {},
    middleColor: {},
    label: {},
    labelType: {},
    format: {}
  },
  emits: ["changeValue", "updateValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const { locale } = useI18n()

const fromValue = ref(props.from)
const toValue = ref(props.to)
const savedFromValue = ref(props.from)
const savedToValue = ref(props.to)

onMounted(() => {
  scrollToBottom()
})

watch(
  [() => props.from, () => props.to],
  ([from, to]) => {
    updateValueFrom(from, true)
    updateValueTo(to, true)
  },
  { immediate: true }
)

watch([savedFromValue, savedToValue], ([from, to]) => {
  emit('updateValue', { from, to })
})

function scrollToBottom() {
  const rangeSlider = document.querySelector('.range-slider')
  if (rangeSlider) {
    rangeSlider.scrollTop = rangeSlider.scrollHeight // Scroll to the bottom of the container
  }
}
function updateValueFrom(number: number | string, save: boolean = false) {
  if (typeof number === 'number') {
    fromValue.value = number
    if (save) {
      savedFromValue.value = number
    }
  }
}
function updateValueTo(number: number | string, save: boolean = false) {
  if (typeof number === 'number') {
    toValue.value = number
    if (save) {
      savedToValue.value = number
    }
  }
}
function inputValueBlur() {
  savedFromValue.value = fromValue.value
  savedToValue.value = toValue.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TextBase, {
      text: _ctx.label,
      type: _ctx.labelType,
      weight: "bold"
    }, null, 8, ["text", "type"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TextFieldStandard, {
            type: 'number',
            numberValue: parseFloat(fromValue.value.toFixed(5)),
            onEmitInput: _cache[0] || (_cache[0] = (v) => updateValueFrom(v)),
            onEmitBlur: inputValueBlur,
            onKeydown: _withKeys(inputValueBlur, ["enter"])
          }, null, 8, ["numberValue"])
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { style: { width: '8px' } }, "-", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(TextFieldStandard, {
            type: 'number',
            numberValue: parseFloat(toValue.value.toFixed(5)),
            onEmitInput: _cache[1] || (_cache[1] = (v) => updateValueTo(v)),
            onEmitBlur: inputValueBlur,
            onKeydown: _withKeys(inputValueBlur, ["enter"])
          }, null, 8, ["numberValue"])
        ])
      ]),
      _createVNode(MinMaxRangeSlider, {
        from: savedFromValue.value,
        to: savedToValue.value,
        min: _ctx.min,
        max: _ctx.max,
        step: _ctx.step,
        fromColor: _ctx.fromColor,
        toColor: _ctx.toColor,
        middleColor: _ctx.middleColor,
        onUpdateValueFrom: _cache[2] || (_cache[2] = (v) => updateValueFrom(v, true)),
        onUpdateValueTo: _cache[3] || (_cache[3] = (v) => updateValueTo(v, true)),
        onChangeValue: _cache[4] || (_cache[4] = (v) => emit('changeValue', v))
      }, null, 8, ["from", "to", "min", "max", "step", "fromColor", "toColor", "middleColor"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", null, _toDisplayString(_unref(formatter)(_ctx.min, _unref(locale), _ctx.format)), 1),
      _createElementVNode("span", null, _toDisplayString(_unref(formatter)(_ctx.max, _unref(locale), _ctx.format)), 1)
    ])
  ]))
}
}

})